import { Component, inject } from '@angular/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ConnectivityService } from '../../services/connectivity.service';
import { PwaInstallService } from '../../services/pwa-install.service';
import { PwaUpdateService } from '../../services/pwa-update.service';

@Component({
  selector: 'app-pwa-banners',
  imports: [NzAlertModule, NzButtonModule, NzIconModule, TranslatePipe],
  templateUrl: './pwa-banners.component.html',
  styleUrls: ['./pwa-banners.component.scss'],
})
export class PwaBannersComponent {
  private readonly connectivity = inject(ConnectivityService);
  readonly pwaUpdate = inject(PwaUpdateService);
  readonly pwaInstall = inject(PwaInstallService);

  readonly online = this.connectivity.online;

  applyUpdate(): void {
    void this.pwaUpdate.applyUpdate();
  }

  dismissIosHint(): void {
    this.pwaInstall.dismissIosHint();
  }
}
